// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Resources } from "../../../Commons/properties/Resources.js";
import { DataCacheToolRayType, DataCacheToolToolType } from "../DataCacheToolEnums.js";
import { Color, Pen } from "../../../Commons/Graphics.js";
import { DataCacheTool } from "../DataCacheTool.js";
import { DynProperty, ColorStyleWidth } from "../../DynProperty.js";

export let AndrewsPitchforkDataCacheTool = function ()
{
    DataCacheTool.apply(this);
    this.InitBlock();
};

AndrewsPitchforkDataCacheTool.prototype = Object.create(DataCacheTool.prototype);

Object.defineProperty(AndrewsPitchforkDataCacheTool.prototype, 'DashedPen', {
    get: function () { return this.dashedPen; }
});

AndrewsPitchforkDataCacheTool.prototype.InitBlock = function ()
{
    DataCacheTool.prototype.InitBlock.apply(this);

    this.ToolType = DataCacheToolToolType.AndrewsPitchFork;
    this.InitPoints(3);
    this.RayType = DataCacheToolRayType.Ray;

    this.dashedPen = this.Pen.copy();
    Pen.ProcessPen(this.dashedPen, Pen.csDotChart);
};

AndrewsPitchforkDataCacheTool.prototype.MinPointsCount = function () { return 3; };
AndrewsPitchforkDataCacheTool.prototype.MaxPointsCount = function () { return 3; };

//#region ICaller

AndrewsPitchforkDataCacheTool.prototype.Properties = function ()
{
    var props = DataCacheTool.prototype.Properties.apply(this);

    var colorStyleWidthRays = new ColorStyleWidth(Color.Empty, this.styleRay, 1);
    colorStyleWidthRays.enableStyleOnly();
    var prop = new DynProperty("Ray style", colorStyleWidthRays, DynProperty.COLOR_STYLE_WIDTH, DynProperty.VISUAL_GROUP);
    prop.propertyComment = Resources.getResource("property.chart.rayStyle");
    props.push(prop);

    return props;
};

AndrewsPitchforkDataCacheTool.prototype.callBack = function (properties)
{
    DataCacheTool.prototype.callBack.call(this, properties);

    var prop = DynProperty.getPropertyByName(properties, "Ray style");
    if (prop) this.StyleRay = prop.value.Style;
};

//#endregion 